import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const StationAdditionsTemplateWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "station-additions-template-wrapper",
  },
)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border: 1px dashed ${greyMui._400};
  border-radius: 5px;
  padding: 12px;
  .add_item_button_wrapper {
    height: 30px;
    display: flex;
  }

  .defaultStation {
    &__title {
      display: inline-block;
      font-weight: 600;
    }

    &__description {
      display: inline-block;
      font-weight: 300;
    }
  }

  .additionalSettings {
    &__title {
      font-weight: 700;
    }
  }
`;

export const StationAdditionDisplayItemStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "station-addition-display-item",
  },
)`
  display: grid;
  grid-template-columns: 120px 50px 1fr 80px;
  align-items: center;
  border: 1px solid ${greyMui._200};
  border-radius: 5px;
  padding: 6px;
`;

export const StationAdditionEditItemStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "station-addition-edit-item",
  },
)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  border: 1px solid ${greyMui._200};
  padding: 10px;
  border-radius: 5px;
  .buttons_edit_view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;
